import { useMemo } from 'react';
import useSWRImmutable from 'swr/immutable';
import { formatTextUppercase } from '@/helpers/common';
import { TRUELAB_PROVIDER_ID } from '@/helpers/conf';
import { fetcherSS } from '@/modules/api';
import { useGetCommonStore } from '@/store';

export interface IProvider {
  id: string;
  title: string;
}

export const useGamesProviders = () => {
  const useCommonStore = useGetCommonStore();
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<IProvider[]>(
    ['/games/providers', isAuthenticated],
    ([url]) => fetcherSS(url)
  );

  const providers = useMemo(
    () =>
      data.map((p) => ({
        ...p,
        title:
          p.id === TRUELAB_PROVIDER_ID ? formatTextUppercase(p.title) : p.title,
      })),
    [data]
  );

  return {
    data: providers,
    error,
    isLoading,
  };
};
